<template>
    <div>
        
        <div v-if="detailTimeLine.detail.length != 0">
            <a-timeline class="mt-30 mb-20">
                <span v-for="(line, index) in detailTimeLine.detail" :key="'line' + index">
                    <a-timeline-item :color="line.type === 'full absent' ? 'grey' : 'red'"
                        v-if="!['0.0', 0, 0.0].includes(parseFloat(line.sum_min))">
                        <p class="mb-10 font-web"> <a-tag :color="line.type === 'full absent' ? 'grey' : 'red'">[ {{
                            line.type
                            === 'full absent' ? 'ไม่พบการบันทึกเวลา' : line.type === 'absent' ? 'สาย' : '' }} ]
                                <br v-if="line.type === 'full absent'">
                                วันที่ {{
                                    moment(`${line.type === 'absent' ? line.log.date : line.log}`).add(543,
                                        'year').locale('th').format('DD / MMMM / YYYY') }}</a-tag></p>
                        <span class="text-dark font-web" style="font-size: 12px;font-weight: 900;"></span>

                        <div style="font-size: 12px;" v-if="line.type === 'absent'">
                            <p class="font-web">บันทึกเวลา เข้า
                                <span class="mr-5 text-success">{{ line.log.start }}</span>
                                ออก
                                <span class="text-danger">{{ ![`${line.log.start}`].includes(`${line.log.end}`) ?
                                    line.log.end : '-' }}</span>
                            </p>
                        </div>
                        <p v-if="line.type === 'absent'" class="font-web text-muted">{{ line.detail }}</p>

                        

                    </a-timeline-item>
                </span>
            </a-timeline>
        </div>
        <div v-else>
            <a-empty class="mt-10">
                <span style="font-size: 12px;" slot="description" class="mb-20 font-web font-weight-bold text-muted">
                    ไม่พบข้อมูล การขาด หรือ มาสาย </span>
            </a-empty>
        </div>
    </div>
</template>

<script>

export default ({
    props: {
        detailTimeLine: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            timelineReverse: false,
        }
    },
})

</script>